import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/$workspaceSlug/")({
  component: WorkspaceHome,
});

function WorkspaceHome() {
  const { workspaceSlug } = Route.useParams();
  return <Navigate to="/$workspaceSlug/inbox" params={{ workspaceSlug }} replace />;
}
